<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="element-header">
          Time management
        </h6>
      </div>
      <div class="element-box">
        <div class="d-flex justify-content-between mb-5">
          <h5>Mitarbeiter - Monatsübersicht (Vorgesetzte Übersicht)</h5>

          <button class="btn btn-primary custom_search_button2 w-auto ms-2" @click="
                        router.push({ name: 'annualOverviewCoordinator', params: { id } });">
            Jahresübersicht
          </button>
        </div>

        <Search
            :userDropdown="userDropdown"
            :filters="filters"
            :loading="isSearching"
            :monthsInYearDropdown="enums.monthsInYear"
            :yearsDropdown="yearsDropdown"
            @search="getCoordinatorMonthlyOverview"/>

        <div class="row align-items-center justify-content-between mt-3">
          <div class="col-auto">
            <PerPage :values="[10, 25, 50, 100]" @update:perPage="getCoordinatorMonthlyOverview"/>

            <ExcelExportButton
                :label="$t('general.excel_export')"
                :loading="isExcelLoaded"
                @click="getExcelExport"/>
          </div>
        </div>
        <div class="table-responsive overflow-auto mt-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th style=" text-align: left; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
              <th>Mitarbeiternr</th>
              <th class="text-end">Arbeitszeit</th>
              <th class="text-end">Soll</th>
              <th class="text-end">Überstunden</th>
              <th class="text-end">davon im Einsatz</th>
              <th class="text-end">Arbeitstage pro Monat</th>
              <th class="text-end">Urlaub</th>
              <th class="text-end">Sonderurlaub</th>
              <th class="text-end">Krankheitstage</th>
              <th class="text-end">Abgehaltene Einheiten</th>
              <th class="text-end">Arbeitsleistung %</th>
              <th class="text-center">Eingereicht zur Überprüfung</th>
              <th class="text-center">Akzeptiert/Genehmigt</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(monthlyOverview) in coordinatorMonthlyOverviewList.data"
                :key="monthlyOverview.id">
              <td>
                <div class="btn-group">
                  <button type="button" class="btn btn-primary dropdown-toggle"
                          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Aktion
                  </button>
                  <div class="dropdown-menu">
                    <button class="dropdown-item"
                            @click="router.push({ name: 'overview', params: { id: monthlyOverview.user.id } });">
                      Übersicht
                    </button>
                    <button class="dropdown-item"
                            @click="router.push({ name: 'hourlyOverview', params: { id: monthlyOverview.user.id } });"
                            href="#">Stundenerfassung
                    </button>
                  </div>
                </div>
              </td>
              <td>{{ monthlyOverview?.user?.fullName }}</td>
              <td class="text-end">{{ monthlyOverview?.workedHours }}</td>
              <td class="text-end">{{ monthlyOverview?.planedHours }}</td>
              <td class="text-end">{{ monthlyOverview?.overtimeHours }}</td>
              <td class="text-end">{{ monthlyOverview?.recalculatedPlanedHours }}</td>
              <td class="text-end">{{ monthlyOverview?.numberOfPlanedWorkingDays }}</td>
              <td class="text-end">{{ monthlyOverview?.numberOfVacationDays }}</td>
              <td class="text-end">{{ monthlyOverview?.numberOfSpecialLeaveDays }}</td>
              <td class="text-end">{{ monthlyOverview?.numberOfSickDays }}</td>
              <td class="text-end">{{ monthlyOverview?.unitsDone }}</td>
              <td class="text-end">{{ monthlyOverview?.workPerformance }}</td>
              <td class="text-center"></td>
              <td class="text-center"></td>
            </tr>
            </tbody>
          </table>
          <div v-if=" coordinatorMonthlyOverviewList.data.length === 1" style="height: 140px">

          </div>
        </div>
        <Pagination v-if="coordinatorMonthlyOverviewList?.pagination?.total_pages > 1"
                    :totalPages="coordinatorMonthlyOverviewList?.pagination?.total_pages"
                    :currentPage="coordinatorMonthlyOverviewList?.pagination?.current_page"
                    :totalItems="coordinatorMonthlyOverviewList?.pagination?.total_items"
                    :perPage="coordinatorMonthlyOverviewList?.pagination?.items_per_page"
                    @pagechanged="getCoordinatorMonthlyOverview"/>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import { timeManagementService } from '@/api/TImeManagement';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { getUsersForCoordinatorOverviewDropdown, getYears } from '@/shared/dropdowns';
import { downloadFile } from '@/shared/functions';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Search from '@/views/App/TimeManagement/TMCoordinatorMonthlyOverview/Search.vue';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import ExcelExportButton from '@/components/ExcelExportButton.vue';

const route                          = useRoute();
const id                             = route.params.id;
const yearsDropdown                  = ref([]);
const userDropdown                   = ref([]);
const { enums }                      = piniaEnumsStore();
const isLoaded                       = ref(false);
const isExcelLoaded                  = ref(false);
const coordinatorMonthlyOverviewList = ref([]);
const currentDate                    = new Date();

let year   = route.query.year;
let month  = route.query.month;
let userId = route.query.userId;

if(userId === undefined){
  userId = null
}

if (!year) {
  year = yearsDropdown.value.at(-1)?.value || new Date().getFullYear();
}
if (!month) {
  month = currentDate.getMonth() + 1;
}
if (userId) {
  userId = +userId;
}

const filters = ref({
  userId: userId,
  year: +year,
  month: +month,
});

const isSearching = ref(false);

async function getExcelExport() {
  await downloadFile(
      '/time-management/monthly-overview-excel-export-coordinator',
      undefined, {...filters.value}, false, 'GET', isExcelLoaded)
}

async function getCoordinatorMonthlyOverview(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  try {
    const perPageRes = coordinatorMonthlyOverviewList.value?.pagination?.items_per_page;
    const { data }   = await timeManagementService.getMonthlyOverviewCoordinator({
          page: page,
          limit: perPage ?? perPageRes,
          ...(passedFilters ? passedFilters : filters.value),
        },
    );

    coordinatorMonthlyOverviewList.value = data;
    isSearching.value                    = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await Promise.all([
    getYears(yearsDropdown),
    getCoordinatorMonthlyOverview(),
    getUsersForCoordinatorOverviewDropdown(userDropdown),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>
.nav.sm {
  width: max-content;
}
</style>